'use es6';

import { Record } from 'immutable';
const defaults = {
  ab: null,
  abStatus: null,
  contentId: null
};
export default class ABTestingParams extends Record(defaults) {
  static from(json) {
    return new ABTestingParams(json);
  }

  compact() {
    return this.reduce((truthyFields, fieldValue, fieldName) => {
      if (fieldValue) {
        truthyFields[fieldName] = fieldValue;
      }

      return truthyFields;
    }, {});
  }

}